import i18n from '../i18n';
import mixin from '../mixins/Mixin';
export default {
  mixins: [mixin],
  methods: {
    translateBlocksName(blocks) {
      var self = this;
      blocks.forEach(function(item) {
        if (item.attributes.label.indexOf('gjs-block-label') > -1) {
          var block1 = item.attributes.label.slice(
            0,
            item.attributes.label.indexOf('gjs-block-label">') + 17,
          );
          item.set({
            label: block1 + self.$t('blocks.' + item.id),
            parent: block1 + self.$t('blocks.' + item.id),
            title: block1 + self.$t('blocks.' + item.id) + '</div>',
          });
        } else {
          item.set({
            label: self.$t('blocks.' + item.id),
            parent: self.$t('blocks.' + item.id),
            title: self.$t('blocks.' + item.id),
          });
        }
      });
    },
    translateStyleManagerName(blocks) {
      var self = this;
      blocks.forEach(function(item) {
        if (item) {
          item.set({
            label: self.$t('blocks.' + item.id),
            name: self.$t('blocks.' + item.id),
          });
          let title = document.querySelector(
            '.gjs-sm-sectors #gjs-sm-' + item.id.toLowerCase() + ' > div.gjs-sm-title',
          );
          let caret = document.querySelector(
            '.gjs-sm-sectors #gjs-sm-' +
              item.id.toLowerCase() +
              ' > div.gjs-sm-title #gjs-sm-caret',
          );
          if (title) {
            title.innerHTML =
              '<i id="gjs-sm-caret" class="fa fa-caret-right"></i>' + self.$t('blocks.' + item.id);
            if (title.classList.contains('gjs-sm-open')) {
              caret.className = 'fa fa-caret-down';
            } else {
              caret.className = 'fa fa-caret-right';
            }
          }
        }
      });
    },
    translatePluginsTitle(comp, type) {
      var self = this;
      let id;
      if (comp === 'image_media') {
        id = 'image-media';
      } else if (comp === 'social_media') {
        id = 'social-media';
      } else if (comp === 'pattern') {
        id = 'pattern';
      }
      let title, buttonCLoseId;
      let titlePluginsMedia = document.querySelector(
        '#' +
          id +
          '-iframe .gjs-mdl-container .gjs-mdl-dialog.gjs-one-bg .gjs-mdl-header.modal-' +
          id,
      );
      let titleImage = document.querySelector(
        '.gjs-mdl-container .gjs-mdl-dialog.gjs-one-bg.gjs-two-color .gjs-mdl-header',
      );
      setTimeout(() => {
        let dropFiles = document.querySelector(
          '.gjs-mdl-container .gjs-mdl-dialog.gjs-one-bg.gjs-two-color .gjs-mdl-content #gjs-mdl-c .gjs-asset-manager .gjs-am-file-uploader > form  #gjs-am-title',
        );
        if (dropFiles) {
          dropFiles.innerText = self.$t('blocks.drop_files');
        }
      }, 100);
      if (titleImage) {
        title = titleImage;
        buttonCLoseId = 'image';
      }
      if (titlePluginsMedia && comp === 'image_media') {
        title = titlePluginsMedia;
        titleImage = null;
        buttonCLoseId = id;
      } else if (titlePluginsMedia && comp === 'social_media') {
        title = titlePluginsMedia;
        titleImage = null;
        buttonCLoseId = id;
      } else if (titlePluginsMedia && comp === 'pattern') {
        title = titlePluginsMedia;
        titleImage = null;
        buttonCLoseId = id;
      }
      if (type === 'image' || type === 'pattern' || type === 'video') {
        type = 'select_' + type;
      }
      self.setTitleImage(title, type, buttonCLoseId);
      self.setCloseImageModal(comp, buttonCLoseId);
    },
    setTitleImage(title, type, buttonCLoseId) {
      title.innerHTML =
        '<div class="gjs-mdl-title">' +
        i18n.t('blocks.' + type) +
        '</div><div id="close-modal-' +
        buttonCLoseId +
        '" class="gjs-mdl-btn-close" data-close-modal>⨯</div>';
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/GrapesMixinTranslate.js